import React, { useContext, useEffect, useRef, useState } from 'react';

import { useForm, Controller } from "react-hook-form";
import { Button, Col, Form, Row } from "react-bootstrap";
import Regex from "../../../Utilities/Regex";
import { useDispatch } from "react-redux";
import { AgentContext } from "../AgentComponent";
import { addAgentAction, getAgentByMobileNumberAction, updateAgentAction } from "../../../Redux/Action/AgentAction";
import Auth from "../../../Utilities/Auth";
import Select from "react-select";
import { locations } from '../../../formatted_state_and_district';


function AgentForm({ formData, formType }) {
    // ref
    const btnRef = useRef()

    // Hook
    const dispatch = useDispatch()

    //Context
    const {
        setAgentAddModalShow,
        setAllAgentReload,
        getSingleAgentData,
        setAgentEditModalShow,
        setGetSingleAgentData
    } = useContext(AgentContext)

    // hook form
    const { control, register, handleSubmit, getValues, reset, setValue, formState: { errors } } = useForm();
    const user_detail = JSON.parse(Auth.header().userdetail)
    // states
    const [newAvatar, setNewAvatar] = useState(null)
    const [selectedState, setSelectedState] = useState(null);
    const [selectedDistrict, setSelectedDistrict] = useState(null);
    const [reRenderThisComponent, setReRenderThisComponent] = useState(false)

    // Convert states into React Select format
    const stateOptions = locations.map((item) => ({
        value: item.state_name,
        label: item.state_name,
    }));

    // District options based on selected state
    const districtOptions =
        selectedState
            ? locations
                .find((s) => s.state_name === selectedState.value)
                ?.districts.map((d) => ({
                    value: d.district_name,
                    label: d.district_name,
                })) || []
            : [];


    //





    // default data set when update
    useEffect(() => {
        if (Object.keys(getSingleAgentData).length != 0) {
            Object.keys(getValues()).map(fieldProp => {

                if (fieldProp == "collection_area_state") {
                    // formData.append(fieldName, data[fieldName].value)
                    setValue(fieldProp, { label: getSingleAgentData[fieldProp], value: getSingleAgentData[fieldProp] })

                    // set their own districts
                    let state_with_their_districts = null
                    for (const S of stateOptions) {
                        if (S.value.toLocaleLowerCase() == getSingleAgentData[fieldProp].toLocaleLowerCase()) {
                            console.log("hi")
                            state_with_their_districts = S
                            break;
                        }
                    }

                    console.log(state_with_their_districts)
                    setSelectedState(state_with_their_districts)

                } else if (fieldProp == "collection_area_district") {
                    // formData.append(fieldName, data[fieldName].value)
                    setValue(fieldProp, { label: getSingleAgentData[fieldProp], value: getSingleAgentData[fieldProp] })
                } else {

                    setValue(fieldProp, getSingleAgentData[fieldProp])
                }
            })
            // re rendering this componet so that all the data can update their own field.
            setReRenderThisComponent(prev => !prev)
        }

    }, [getSingleAgentData])

    const onSubmit = async data => {
        const name = data.full_name || ""
        const mobile = data.mobile + ""
        const prefix = name.replace(/\s+/g, "").substring(0, 2).toLowerCase();
        const post_fix = mobile.slice(-4);


        let formData = new FormData()
        formData.append("new_avatar", newAvatar)
        Object.keys(getSingleAgentData).length != 0 && formData.append("agent_id", getSingleAgentData.id)
        Object.keys(getSingleAgentData).length != 0 && formData.append("avatar", getSingleAgentData.avatar)
        Object.keys(data).map(fieldName => {
            if (fieldName == "collection_area_state") {
                formData.append(fieldName, data[fieldName]?.value || "")
            } else if (fieldName == "collection_area_district") {
                formData.append(fieldName, data[fieldName]?.value || "")
            } else {
                formData.append(fieldName, data[fieldName])
            }

        })
        formData.append("user_name", !getSingleAgentData?.is_admin ? data.mobile : getSingleAgentData?.user_name)
        Object.keys(getSingleAgentData).length == 0 && formData.append("password", prefix + post_fix)

        const payload = {
            data: formData,
            reset,
            btnRef,
            setAllAgentReload,
            setAgentAddModalShow,
            setAgentEditModalShow,
            setAgentEditModalShow
        }
        if (Object.keys(getSingleAgentData).length == 0) {
            dispatch(addAgentAction(payload))

        } else {

            dispatch(updateAgentAction(payload))
            // console.log(getSingleAgentData)


        }

        // console.log(formData)

    }
    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)}>
                {/*Agent full_name field*/}
                <Row>
                    <Col md={12} sm={12}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Collector Image</Form.Label>
                            <Form.Control
                                type="file"
                                placeholder="Enter Agent Name"
                                onChange={e => {
                                    setNewAvatar(e.target?.files[0])
                                }}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={12} sm={12}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Name</Form.Label>
                            <Form.Control
                                type="text"
                                disabled={!user_detail?.is_admin}
                                {...register("full_name", {
                                    required: true,
                                    minLength: 3
                                })}
                            />

                            {/* validation message*/}
                            {errors.full_name && <span className="text-danger">
                                {errors.full_name.type === "required" && "Please Give Agent Name"}
                                {errors.full_name.type === "minLength" && "Full name must should be more than 2 character"}
                            </span>}
                        </Form.Group>
                    </Col>

                    <Col md={6} sm={12}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Mobile No.</Form.Label>
                            <Form.Control
                                type="text"
                                disabled={!user_detail?.is_admin}
                                maxLength={10} // <-- Hard limit on input
                                {...register("mobile", {
                                    required: true,
                                    pattern: Regex.mobile(),
                                    pattern: {
                                        value: /^[0-9]{10}$/,
                                        message: "Mobile number must be 10 digits",
                                    },
                                })}

                                onBlur={(e) => {
                                    const mobile = +e?.target?.value || 0
                                    if (mobile > 9) {
                                        // handle field disablity
                                        const handleFieldDisability = (disable_status) => {
                                            e.target.disabled = disable_status || false
                                        }
                                        // making payload
                                        const payload = {
                                            data: { mobile_no: mobile },
                                            agent_id: getSingleAgentData?.id || null,
                                            handleFieldDisability
                                        }

                                        // action dispatch
                                        dispatch(getAgentByMobileNumberAction(payload))
                                    }
                                }}
                            />

                            {/* validation message*/}
                            {errors.mobile && <span className="text-danger">
                                {errors.mobile.type === "required" && "Please Give Agent Mobile No."}
                                {errors.mobile.type === "pattern" && "Please Give Valid Mobile No."}
                            </span>}
                        </Form.Group>
                    </Col>
                    <Col md={6} sm={12}>
                        <Form.Group className="mb-3" controlId="formBasicEmails">
                            <Form.Label>
                                WhatsApp No.
                                <span
                                    disabled={!user_detail?.is_admin}
                                    className=" text-decoration-underline "
                                    style={{ "cursor": "pointer" }}
                                    onClick={(e) => {
                                        setValue("whats_app", getValues("mobile"))
                                        setReRenderThisComponent(prev => !prev)
                                    }}
                                >( Same As Mobile ✓ )</span>
                            </Form.Label>
                            <Form.Control
                                type="text"
                                disabled={!user_detail?.is_admin}
                                maxLength={10} // <-- Hard limit on input
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/\D/g, "").slice(0, 10);
                                }}
                                {...register("whats_app", {
                                    required: false,
                                    pattern: Regex.numeric()
                                })}
                            />

                            {/* validation message*/}
                            {errors.whats_app && <span className="text-danger">
                                {errors.whats_app.type === "required" && "Please Give WhatsApp No."}
                                {errors.whats_app.type === "pattern" && "Please Give Number"}
                            </span>}
                        </Form.Group>
                    </Col>

                    <Col md={6} sm={12}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>State</Form.Label>
                            <Controller
                                name="collection_area_state"
                                control={control}
                                // rules={{ required: "State is required" }}
                                rules={{ required: false }}
                                render={({ field }) => (
                                    <Select
                                        {...field}
                                        value={getValues("collection_area_state") ? getValues("collection_area_state") : null}
                                        options={stateOptions}
                                        placeholder="Select State"
                                        isDisabled={!user_detail?.is_admin}
                                        onChange={(value) => {
                                            field.onChange(value);
                                            setSelectedState(value || null);
                                            setValue("collection_area_district", null)

                                        }}
                                    />
                                )}
                            />


                            {/* validation message*/}
                            {errors.collection_area_state && <span className="text-danger">
                                {errors.collection_area_state.type === "required" && "Please Select State"}
                            </span>}
                        </Form.Group>
                    </Col>

                    <Col md={6} sm={12}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>District</Form.Label>
                            <Controller
                                name="collection_area_district"
                                control={control}
                                // rules={{ required: "District is required" }}
                                rules={{ required: false }}
                                render={({ field }) => (
                                    <Select
                                        {...field}
                                        value={getValues("collection_area_district") ? getValues("collection_area_district") : null}
                                        options={districtOptions}
                                        placeholder="Select District"
                                        isDisabled={!selectedState}
                                        onChange={field.onChange}
                                    />
                                )}
                            />
                            {/* <Form.Control
                                type="text"
                                placeholder="Enter District Name"
                                {...register("collection_area_district", {
                                    required: true
                                })}
                            /> */}

                            {/* validation message*/}
                            {errors.collection_area_district && <span className="text-danger">
                                {errors.collection_area_district.type === "required" && "Please Select District"}
                            </span>}
                        </Form.Group>
                    </Col>

                    <Col md={6} sm={12}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Police Station</Form.Label>
                            <Form.Control
                                type="text"
                                disabled={!user_detail?.is_admin}
                                {...register("collection_area_police_station", {
                                    required: false
                                })}
                            />

                            {/* validation message*/}
                            {errors.collection_area_police_station && <span className="text-danger">
                                {errors.collection_area_police_station.type === "required" && "Please Give Police Station"}
                            </span>}
                        </Form.Group>
                    </Col>

                    <Col md={3} sm={12} className='d-none'>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Post Office</Form.Label>
                            <Form.Control
                                type="text"
                                disabled={!user_detail?.is_admin}
                                {...register("collection_area_post_office", {
                                    required: false
                                })}
                            />

                            {/* validation message*/}
                            {/* {errors.collection_area_post_office && <span className="text-danger">
                                {errors.collection_area_post_office.type === "required" && "Please Give Post Office"}
                            </span>} */}
                        </Form.Group>
                    </Col>
                    <Col md={3} sm={12} className='d-none'>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Pincode</Form.Label>
                            <Form.Control
                                type="text"
                                disabled={!user_detail?.is_admin}
                                {...register("collection_area_pincode", {
                                    required: false
                                })}
                            />

                            {/* validation message*/}
                            {/* {errors.collection_area_pincode && <span className="text-danger">
                                {errors.collection_area_pincode.type === "required" && "Please Give Pincode"}
                            </span>} */}
                        </Form.Group>
                    </Col>
                    <Col md={6} sm={12}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Village</Form.Label>
                            <Form.Control
                                type="text"

                                {...register("collection_area_village", {
                                    required: false
                                })}
                            />

                            {/* validation message*/}
                            {/* {errors.collection_area_village && <span className="text-danger">
                                {errors.collection_area_village.type === "required" && "Please Give Village Name"}
                            </span>} */}
                        </Form.Group>
                    </Col>
                    <Col md={6} sm={12}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Neighborhood</Form.Label>
                            <Form.Control
                                type="text"
                                disabled={!user_detail?.is_admin}
                                {...register("collection_area_para", {
                                    required: false
                                })}
                            />

                            {/* validation message*/}
                            {/* {errors.collection_area_para && <span className="text-danger">
                                {errors.collection_area_para.type === "required" && "Please Give Para Name"}
                            </span>} */}
                        </Form.Group>
                    </Col>

                    <Col md={6} sm={12}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Place</Form.Label>
                            <Form.Control
                                type="text"
                                disabled={!user_detail?.is_admin}
                                {...register("collection_area_place", {
                                    required: false
                                })}
                            />


                        </Form.Group>
                    </Col>
                    <Col md={6} sm={12}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>City</Form.Label>
                            <Form.Control
                                type="text"
                                disabled={!user_detail?.is_admin}
                                {...register("collection_area_city", {
                                    required: false
                                })}
                            />

                            {/* validation message*/}
                            {/* {errors.collection_area_city && <span className="text-danger">
                                {errors.collection_area_city.type === "required" && "Please Give City name"}
                            </span>} */}
                        </Form.Group>
                    </Col>

                    {/* <Col md={6} sm={12}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>User Name</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter Agent Mobile No."
                                {...register("user_name", {
                                    required: true,
                                    // pattern:Regex.numeric()
                                })}
                            /> */}

                    {/* validation message*/}
                    {/* {errors.user_name && <span className="text-danger">
                                {errors.user_name.type === "required" && "Please Give Agent phone No."} */}
                    {/*{errors.user_name.type === "pattern" && "Please Give Agent phone No."}*/}
                    {/* </span>}
                        </Form.Group>
                    </Col> */}
                    {Object.keys(getSingleAgentData).length == 0 && <>
                        {/* <Col md={6} sm={12}>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Password</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter Password"
                                    {...register("password", {
                                        required: true
                                    })}
                                /> */}

                        {/* validation message*/}
                        {/* {errors.password && <span className="text-danger">
                            {errors.password.type === "required" && "Please Give Password"}
                        </span>} */}
                        {/* </Form.Group>
                        </Col> */}
                        <Col md={6} sm={12}>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Balance</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter Amount"
                                    value="100000"
                                    disabled
                                    {...register("balance", {
                                        required: false,
                                        pattern: Regex.numeric()
                                    })}
                                />

                                {/* validation message*/}
                                {errors.balance && <span className="text-danger">
                                    {errors.balance.type === "required" && "Please Give Amount"}
                                    {errors.balance.type === "pattern" && "Please Valid Amount"}
                                </span>}
                            </Form.Group>
                        </Col>
                    </>}

                </Row>


                <Button ref={btnRef} variant="success" type="submit" className="submit ">
                    {Object.keys(getSingleAgentData).length == 0 ? "Submit" : "Update"}
                </Button>


            </form>
        </>
    );
}

export default AgentForm;